import React, { useContext } from 'react';
import { EditorContext } from '../EditorCommon/EditorContext';
import { ExtraProductGroupCard } from './ExtraProductGroupCard';

export function ExtraProductsList(props: {

}) {
    const ec = useContext(EditorContext);


    return (
        <div className="extra-product-list"
            style={{
                display: "flex",
                flexDirection: "column"
            }}>

            {ec.cabinetService.chainInfo.extraProducts.map(extraProductGroup => (
                <ExtraProductGroupCard
                    productGroup={extraProductGroup}
                    key={extraProductGroup.id}
                />
            ))}

        </div>
    );
}
